import { delData, getData, postData, patchData } from '../../../utils/fetch-api-util';
import { CoachProfileType, SortCoachProfilesPayload, FormCoachProfileType } from '../../../types/coachProfile';
import { API_URLS } from '../../../constants/urls/api-urls';

export interface CoachProfileRequestParams {
  take?: number;
  page?: number;
  country?: string;
  sort?: boolean;
}

export interface PlayerProfileRequestParams {
  country?: string;
}

export interface CoachProfileTypeResponse {
  coachProfiles: CoachProfileType[];
  total: number;
}

export interface PlayerProfileTypeResponse {
  widgets: [];
  total: number;
}

interface SuccessResponse {
  success: boolean;
}

export const getCoachProfileListRepository = async (
  data?: CoachProfileRequestParams,
): Promise<CoachProfileTypeResponse> => {
  const response = await getData<CoachProfileRequestParams, CoachProfileTypeResponse>(API_URLS.COACH_PROFILE_API, data);
  return response.data;
};

export const getPlayerProfileListRepository = async (
  data?: PlayerProfileRequestParams,
): Promise<PlayerProfileTypeResponse> => {
  const response = await getData<PlayerProfileRequestParams, PlayerProfileTypeResponse>(
    API_URLS.PLAYER_PROFILE_API,
    data,
  );
  return response.data;
};

export const postCreateCoachProfileRepository = async (payload: FormCoachProfileType): Promise<void> => {
  await postData<FormCoachProfileType, SuccessResponse>(API_URLS.COACH_PROFILE_API, payload);
};

export const patchUpdateCoachProfileRepository = async (payload: CoachProfileType): Promise<void> => {
  await patchData<CoachProfileType, SuccessResponse>(API_URLS.COACH_PROFILE_URL_WITH_ID(payload?.id || ''), payload);
};

export const patchActiveCoachProfileRepository = async (payload: CoachProfileType): Promise<void> => {
  await patchData<CoachProfileType, SuccessResponse>(
    API_URLS.COACH_PROFILE_ACTIVE_URL_WITH_ID(payload?.id || ''),
    payload,
  );
};

export const deleteCoachProfileRepository = async (id: string): Promise<void> => {
  await delData<SuccessResponse>(API_URLS.COACH_PROFILE_URL_WITH_ID(id));
};

export const postSortCoachProfilesRepository = async (payload: SortCoachProfilesPayload): Promise<void> => {
  await postData<SortCoachProfilesPayload, SuccessResponse>(API_URLS.COACH_PROFILE_SORT, payload);
};
